<template>
  <div
    class="auth-wrapper pr-15 pl-15"
    :style="{
      backgroundImage: 'url(' + $store.getters[`customization/loginBg`] + ')'
    }"
  >
    <div class="language">
      <LanguageBar />
    </div>
    <b-row class="register-form">
      <b-col class="register-content-col">
        <img class="logo-image" :src="$store.getters[`customization/logo`]" />
        <div class="mode-selection">
          <div class="mode-selection-item">
            <div class="mode-item-title">
              {{ $t('text.already_registered') }}?
            </div>
            <div class="mode-item-desc">
              {{ $t('text.already_registered_desc') }}
            </div>
            <el-button
              class="mode-item-btn"
              :loading="loading"
              @click="signIn()"
              >{{ $t('text.sign_in') | capitalize }}</el-button
            >
          </div>
        </div>
        <OrganisationSelection
          ref="organisationSelection"
          :organisations="organisations"
          @assignPermissionSuccess="redirectToHomePage"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LanguageBar from '@/components/LanguageBar.vue'
import OrganisationSelection from '@/components/signIn/OrganisationSelection.vue'
import { azureAD } from '@/const'
import { encode as base64encode } from 'base64-arraybuffer'
import randomstring from 'randomstring'
import '@/assets/font/font.css'
import '@/assets/css/login.scss'
import '@/assets/css/global.scss'
import $ from 'jquery'
export default {
  data() {
    return {
      code: '',
      loading: false,
      signUpLoading: false,
      token: '',
      accessToken: '',
      organisations: [],
      fullScreenLoading: null,
      fromApp: false,
      informationFromApp: {
        // if mobile app redirect to dashboard site, url will with below information
        accessToken: null,
        organisationId: null
      }
    }
  },
  components: {
    LanguageBar,
    OrganisationSelection
  },
  watch: {
    loading() {
      if (this.loading && (this.code || this.fromApp)) {
        this.showFullScreenLoading()
      } else {
        this.closeFullScreenLoading()
      }
    },
    signUpLoading() {
      if (this.signUpLoading && (this.code || this.fromApp)) {
        this.showFullScreenLoading()
      } else {
        this.closeFullScreenLoading()
      }
    }
  },
  mounted() {
    // Compatible in Safari browser, click the sign in and sign up buttons. After returning to this page, the button keeps loading
    $(window).bind('pageshow', () => {
      this.loading = false
      this.signUpLoading = false
    })
    if (this.$route.query) {
      if (this.$route.query.from && this.$route.query.from === 'app') {
        this.fromApp = true
        this.informationFromApp = {
          accessToken: this.$route.query.code || null,
          organisationId: this.$route.query.organisationId || null
        }
        // from app, link will add access token and from app params, then redirect to dashboard, not run Azure AD workflow
        this.appLogin()
        return false
      }
      if (this.$route.query.code) {
        // If code is returned, code is used to exchange for token
        this.code = this.$route.query.code
        this.getAzureToken()
      } else if (this.$route.query.error_description) {
        // If an error message is returned, an error message is displayed
        let errMsg = this.$route.query.error_description
        errMsg = errMsg.substring(
          errMsg.indexOf(':') + 1,
          errMsg.indexOf('Correlation ID')
        )
        this.showErrorMsg(errMsg)
      }
    }
  },
  methods: {
    async generateCodeChallenge(codeVerifier) {
      const encoder = new TextEncoder()
      const data = encoder.encode(codeVerifier)
      const digest = await window.crypto.subtle.digest('SHA-256', data)
      const base64Digest = base64encode(digest)
      return base64Digest
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '')
    },
    signUp() {
      this.signUpLoading = true
      const codeVerifier = randomstring.generate(128)
      localStorage.setItem('codeVerifier', codeVerifier)
      this.generateCodeChallenge(codeVerifier).then(challenge => {
        const currentLocale = this.$store.state.locale.currentLocale
        this.$store.commit('user/SET_POLICY', azureAD.signUpPolicy)
        window.open(
          `${azureAD.hostName}/${azureAD.tenantId}/oauth2/v2.0/authorize?p=${azureAD.signUpPolicy}&client_id=${azureAD.clientId}&nonce=defaultNonce&redirect_uri=${window.location.origin}/sign-in&scope=openid&response_type=code&prompt=login&ui_locales=${currentLocale}&code_challenge=${challenge}&code_challenge_method=S256`,
          '_self'
        )
      })
    },
    signIn() {
      this.loading = true
      const codeVerifier = randomstring.generate(128)
      localStorage.setItem('codeVerifier', codeVerifier)
      this.generateCodeChallenge(codeVerifier).then(challenge => {
        this.$store.commit('user/SET_POLICY', azureAD.policy)
        window.open(
          `${azureAD.hostName}/${azureAD.tenantId}/${azureAD.policy}/oauth2/v2.0/authorize?client_id=${azureAD.clientId}&response_type=code&redirect_uri=${window.location.origin}/sign-in&response_mode=query&scope=${azureAD.clientId}%20offline_access&code_challenge=${challenge}&code_challenge_method=S256`,
          '_self'
        )
      })
    },
    calcLoading(isLoading) {
      if (
        !localStorage.getItem('currentPolicy') ||
        localStorage.getItem('currentPolicy') === azureAD.policy
      ) {
        this.loading = isLoading
      } else {
        this.signUpLoading = isLoading
      }
    },
    getAzureToken() {
      this.calcLoading(true)
      this.$store
        .dispatch('user/getAzureToken', this.code)
        .then(() => {
          this.calcLoading(false)
          if (
            !localStorage.getItem('currentPolicy') ||
            localStorage.getItem('currentPolicy') === azureAD.policy
          ) {
            this.verifyUser()
          } else {
            this.$router.push('/register')
          }
        })
        .catch(() => {
          this.calcLoading(false)
        })
    },
    verifyUser() {
      this.calcLoading(true)
      this.$store
        .dispatch('user/verifyUser')
        .then(response => {
          this.calcLoading(false)
          if (response.data.success) {
            this.organisations = response.data.data.Organisations
            if (this.organisations.length > 1) {
              if (this.fromApp) {
                this.switchToSelectedOrganisation()
                this.redirectToHomePage()
              } else {
                this.showOrganisationSelection()
              }
            } else if (this.organisations.length === 1) {
              this.$store.dispatch(
                'user/assignPermission',
                this.organisations[0]
              )
              this.redirectToHomePage()
            } else {
              this.showErrorMsg(
                'You do not have permission to access this site. Please contact the website administrator.'
              )
            }
          } else {
            if (response.data.errorcode === 804) {
              this.handleOrgErr()
            } else {
              this.showErrorMsg(response.data.msg)
            }
          }
        })
        .catch(() => {
          this.calcLoading(false)
        })
    },
    switchToSelectedOrganisation() {
      if (this.informationFromApp.organisationId) {
        let selectedOrganisation = this.organisations.filter(organisation => {
          return (
            organisation.OrganisationName.OrganisationId ===
            this.informationFromApp.organisationId
          )
        })
        if (selectedOrganisation.length) {
          this.$store.dispatch('user/assignPermission', selectedOrganisation[0])
        } else {
          this.$store.dispatch('user/assignPermission', this.organisations[0])
        }
      } else {
        this.$store.dispatch('user/assignPermission', this.organisations[0])
      }
    },
    redirectToHomePage() {
      this.$router.push({
        path: '/'
      })
    },
    showErrorMsg(msg) {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${msg}</div>` +
          `<img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.sign_in_failed'),
        {
          confirmButtonText: this.$t('text.ok').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: false,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          showCancelButton: false
        }
      ).then(() => {
        this.$store.dispatch('user/logout')
      })
    },
    handleOrgErr() {
      this.showErrorMsg(
        'You do not have permission to access this site. Please contact the website administrator.'
      )
    },
    showOrganisationSelection() {
      this.$refs.organisationSelection.openDialog()
    },
    getErrorMsg(code) {
      let msg = null
      switch (code) {
        case 620:
          msg = this.$t('text.verify_error_msg_620')
          break
        case 622:
          msg = this.$t('text.verify_error_msg_622')
          break
      }
      return msg
    },
    showFullScreenLoading() {
      this.fullScreenLoading = this.$loading({
        lock: true,
        text: this.$t('text.signing_in'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    closeFullScreenLoading() {
      if (this.fullScreenLoading) {
        this.fullScreenLoading.close()
      }
    },
    appLogin() {
      if (!this.informationFromApp.accessToken) {
        this.showErrorMsg('Miss access token!')
        return false
      }
      this.calcLoading(true)
      this.$store
        .dispatch('user/appLogin', this.informationFromApp.accessToken)
        .then(() => {
          this.calcLoading(false)
          this.verifyUser()
        })
        .catch(() => {
          this.calcLoading(false)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-wrapper .register-form {
  .common-btn {
    width: 100%;
  }
}
</style>
